export const PAY_CONFIGURATION_TABS = {
    COMPANY: "pay-config-company",
    SIGNATORIES: "pay-config-signatories",
    BANK_ACCOUNTS: "pay-config-bank-accounts",
    PAY_SCHEDULES: "pay-config-pay-schedules",
    WORKPLACES: "pay-config-workplaces",
    FILINGS: "pay-config-filings",
    TAX_SETTINGS: "pay-config-tax-settings"
}

// Tab number mapping (1-indexed)
export const TAB_NUMBERS: Record<string, number> = {
    [PAY_CONFIGURATION_TABS.COMPANY]: 1,
    [PAY_CONFIGURATION_TABS.SIGNATORIES]: 2,
    [PAY_CONFIGURATION_TABS.BANK_ACCOUNTS]: 3,
    [PAY_CONFIGURATION_TABS.PAY_SCHEDULES]: 4,
    [PAY_CONFIGURATION_TABS.WORKPLACES]: 5,
    [PAY_CONFIGURATION_TABS.FILINGS]: 6,
    [PAY_CONFIGURATION_TABS.TAX_SETTINGS]: 7,
}

// Reverse mapping: number to tab ID
export const TAB_NUMBER_TO_ID: Record<number, string> = {
    1: PAY_CONFIGURATION_TABS.COMPANY,
    2: PAY_CONFIGURATION_TABS.SIGNATORIES,
    3: PAY_CONFIGURATION_TABS.BANK_ACCOUNTS,
    4: PAY_CONFIGURATION_TABS.PAY_SCHEDULES,
    5: PAY_CONFIGURATION_TABS.WORKPLACES,
    6: PAY_CONFIGURATION_TABS.FILINGS,
    7: PAY_CONFIGURATION_TABS.TAX_SETTINGS,
}

